import { PRIZE_POOLS } from "../home/constants.js";

export { PRIZE_POOLS as ADMIN_PRIZE_POOLS };

export const LAST_DISTRIBUTION_TIME = "2026.4.23";
/** 首页奖金池等级定义（人数、金额由链上接口填充） */
export const PRIZE_POOL_LEVELS = [
  { id: "v1", label: "V1池" },
  { id: "v2", label: "V2池" },
  { id: "v3", label: "V3池" },
  { id: "v4", label: "V4池" },
  { id: "v5", label: "V5池" },
];
